<template lang="pug">
    Tabs(type="card" style="background: #e3e8ee;padding:16px;")
        TabPane(:label='$t("accountInfo.plan.usageAmountText")')
            Table( max-height="500" :columns="qtyColumns" :data="userItmeLogObj" :disabled-hover="true" show-summary )
                template(slot-scope="{row}" slot="items")
                    div(v-for="item in row.items" :key="row.itemId")
                        span {{item.ItemName}}
                template(slot-scope="{row}" slot="useDay")
                    div(v-if="row.up_to")
                        span(v-if="row.useDay>0" style="text-decoration: line-through;") {{separator(row.useDay)}} 
                        span &emsp;
                        span(v-if="row.useDay-row.up_to>0") {{separator(row.useDay-row.up_to)}}
                        span(v-else) 0
                    div(v-else)
                        span {{row.useDay}} 
        TabPane(:label='$t("accountInfo.plan.ResourceText")')
            Table( max-height="500" :columns="objColumns" :data="objData" show-summary :disabled-hover="true")
                template(slot-scope="{row}" slot="itemName")
                    span(v-if="row.itemName == 'basic' || row.itemName == 'pro'") {{$t("accountInfo."+row.itemName)}} 
                    span(v-else) {{row.itemName}} 
</template>

<script>
export default {
    name: "PaymentCrtTabs",
    components: {},
    data() {
        return {
            isLoading: false,
            objColumns: [
                { title: "ItemName", align: "center", key: "itemName", slot: "itemName" },
                { title: "CreatDate", align: "center", key: "from" },
            ],
            qtyColumns: [
                { title: "RecordDate", align: "center", key: "recordDate" },
                // { title: "Items", align: "center", key: "items", slot: "items" },
                { title: "Qty", align: "center", key: "useDay", slot: "useDay" },
            ],
        };
    },
    props: {
        shape: { default: "circle" },
        objData: { title: "", align: "center", key: "" },
        userItmeLogObj: {},
    },
    watch: {},
    created() {},
    mounted() {},
    methods: {
        separator(numb) {
            var str = numb.toString().split(".");
            str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return str.join(".");
        },
    },
    computed: {},
    beforeDestroy() {},
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/PaymentCertTabs.vue